import { connect } from 'react-redux';

import { UPLOAD_MULTIPLE_MEDIA } from 'store/media/actionTypes';

import AddDiscoveryPlaceImages from './AddDiscoveryPlaceImages';

const mapStateToProps = (state) => ({
  isLoadingUploadMultipleMedia: state.Media.isLoadingUploadMultipleMedia,
});

const mapDispatchToProps = (dispatch) => ({
  actionUploadMultiMedia: (payload) => dispatch({
    type: UPLOAD_MULTIPLE_MEDIA,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddDiscoveryPlaceImages);
